/* eslint-disable */
import * as MUI from '@material-ui/core';
import React from 'react';
import { last, first } from 'lodash';
import cn from 'classnames';
import { CalendarValueType, CalendarMultipleValueType, ICalendarInputComponentProps } from '../../../shared';
import { useStyles, useStylesInput, useStylesLabel, useStylesField } from './InputStyles';
import CalendarIcon from '../../../../../icons/Calendar';

type CalendarBASFInputHandlerType = (value: CalendarValueType | CalendarMultipleValueType) => void;
type CalendarBASFInputPropsType = ICalendarInputComponentProps & { disabled?: boolean, label?: string, onChange: CalendarBASFInputHandlerType, setRef: (elem: HTMLInputElement) => void };
const prevent = (e) => e.preventDefault();
export const Input: React.FC<CalendarBASFInputPropsType> = props => {
  const value = props.displayValue;
  const open = props.open;

  const clickHandler = () => {
    if (!props.disabled) {
      props.onToggleOpenState();
    }
  };

  const classes = useStyles(props);
  const fieldClasses = useStylesField(props);
  const inputClasses = useStylesInput(props);
  const labelClasses = useStylesLabel(props);

  React.useEffect(() => {
    if (props.value) {
      props.onChange(props.value);
    }
  }, [props.value]);

  return React.useMemo(() => {
    return (<MUI.TextField
      disabled={props.disabled}
      label={props.label}
      value={(props.multiple && value.length) ? `${value[0]} - ${last(value)}` : value}
      onClick={clickHandler}
      onChange={prevent}
      classes={fieldClasses}
      InputProps={{
        ref: props.setRef,
        className: cn({ 'focus': open }),
        classes: inputClasses,
        endAdornment: <CalendarIcon className={cn(classes.icon, { 'focus': open })} />
      }}
      InputLabelProps={{
        shrink: true,
        className: cn({ 'focus': open }),
        classes: labelClasses
      }}
    />);
  }, [value, open]);
}